import * as moment from "moment";
import { IMenuOptionModel, MenuOptionModel } from "./menu-option.model";
import { IOptionModel, OptionModel } from "./option.model";

export interface IMenuModel {
  id?: number;
  name: string;
  module: number;
  is_enabled: boolean;
  icon:string;
  is_visible: boolean;
  name_translate: string;
  description_translate: string;
  order_visible: number;
  created?: moment.Moment;
  modified?: moment.Moment;
  options?: Array<IMenuOptionModel|IOptionModel>;
}

export interface IResultMenuModel {
  count: number;
  next: string;
  previous: string;
  results: IMenuModel[];
}

export class MenuModel {
  id?: number;
  name: string;
  module: number;
  isEnabled: boolean;
  isVisible: boolean;
  link: string;
  icon: string;
  tooltip: string;
  nameTranslate: string;
  descriptionTranslate: string;
  orderVisible: number;
  paramOptionName:string;
  created?: moment.Moment;
  modified?: moment.Moment;
  options?: any[];

  constructor() {
    this.isEnabled = true;
    this.isVisible = true;
    this.orderVisible = 1;
  }

  static fromObject(menu: IMenuModel, menuUser: boolean = false): MenuModel {
    let obj = new MenuModel();
    obj.id = menu.id;
    obj.name = menu.name;
    obj.module = menu.module;
    obj.isEnabled = menu.is_enabled;
    obj.isVisible = menu.is_visible;
    obj.nameTranslate = menu.name_translate;
    obj.descriptionTranslate = menu.description_translate;
    obj.orderVisible = menu.order_visible;
    obj.icon = menu.icon;
    obj.created = moment(menu.created);
    obj.modified = moment(menu.modified);
    if (menuUser){
      obj.options = (menu.options && menu.options.length > 0) ? OptionModel.fromObjectArray(obj.name,menu.options as IOptionModel[]) : [];
    } else {
      obj.options = (menu.options && menu.options.length > 0) ? MenuOptionModel.fromObjectArray(menu.options as IMenuOptionModel[]): [];
    }
    return obj;
  }

  static fromObjectArray(menus: IMenuModel[], menuUser: boolean = false): MenuModel[] {
    return menus.map((menu: IMenuModel) => MenuModel.fromObject(menu, menuUser));
  }
}

export class ResultMenuModel {
  count: number = 0;
  next: string;
  previous: string;
  results: MenuModel[] = [];

  constructor() {
    this.count = 0;
  }

  static fromObject(result: IResultMenuModel, menuUser: boolean = false): ResultMenuModel {
    let obj = new ResultMenuModel();
    obj.count = result.count | 0;
    obj.next = result.next;
    obj.previous = result.previous;
    obj.results = (result.results && result.results.length > 0) ? MenuModel.fromObjectArray(result.results, menuUser) : [];
    return obj;
  }
}
